import type { FC } from 'react';
import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import DatePicker from 'src/components/global/DatePicker';
import type { DashboardOptions } from './types';

const selectStyle = {
  backgroundColor: '#FFFFFF',
  minHeight: 40,
};

const renderSelect = (
  name: keyof DashboardOptions,
  placeholder: string,
  value: string,
  options: { value: string; label: string }[],
  changeFilter: (name: string, value: string) => void,
) => (
  <FormControl fullWidth size="small">
    <Select
      value={value || ''}
      displayEmpty
      name={name}
      onChange={(e) => changeFilter(e.target.name, e.target.value)}
      style={selectStyle}
    >
      <MenuItem value="">{placeholder}</MenuItem>
      {options.map((option) => (
        <MenuItem key={`${name}-${option.value}`} value={option.value}>
          <Typography
            fontSize="p"
            sx={{
              fontSize: '1rem',
              maxWidth: 700,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
            }}
          >
            {option.label}
          </Typography>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export const SearchByFilters: FC<{
  onSubmit: Function,
  changeFilter: any,
  formFilter: any,
  options: DashboardOptions,
  loading?: boolean,
}> = ({
  onSubmit,
  changeFilter,
  formFilter,
  options,
  loading = false,
}) => (
  <>
    <Grid
      container
      spacing={2}
      style={{
        paddingBottom: 24,
      }}
    >
      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        <DatePicker
          value={formFilter.startDate}
          label="Desde:"
          name="startDate"
          onChange={changeFilter}
        />
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        <DatePicker
          value={formFilter.endDate}
          label="Hasta:"
          name="endDate"
          onChange={changeFilter}
        />
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        {renderSelect('convenio', 'CONVENIO', formFilter.convenio, options.convenio, changeFilter)}
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        {renderSelect('plaza', 'PLAZA', formFilter.plaza, options.plaza, changeFilter)}
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        {renderSelect('fuvexEmpresa', 'FUVEX - EMPRESA', formFilter.fuvexEmpresa, options.fuvexEmpresa, changeFilter)}
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        {renderSelect('equipo', 'EQUIPO', formFilter.equipo, options.equipo, changeFilter)}
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        {renderSelect('entidad', 'ENTIDAD', formFilter.entidad, options.entidad, changeFilter)}
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        {renderSelect('canalPago', 'CANAL DE PAGO', formFilter.canalPago, options.canalPago, changeFilter)}
      </Grid>

      <Grid item xl={2} lg={3} md={4} sm={6} xs={12}>
        <Button
          onClick={() => onSubmit()}
          value="Aceptar"
          title="Aceptar"
          color="primary"
          variant="contained"
          fullWidth
          style={{ minHeight: 40 }}
          disabled={loading}
        >
          Consultar
        </Button>
      </Grid>
    </Grid>
  </>
);
